import { axiosInstance } from '../../lib/helpers'

const BASE_PATH = '/organization'

export const createOrganizationApiMethod = (request: any) =>
  axiosInstance.post(`${BASE_PATH}/`, request)
